import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=80e7256a&scoped=true"
import script from "./SplitButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SplitButton.vue?vue&type=style&index=0&id=80e7256a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e7256a",
  null
  
)

export default component.exports